import React, {useState} from "react";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import "./applications.css";
import {useGetApplicationsQuery, useUpdateUserMutation} from "../../../store/reducers/adminApi";
import {Link} from "react-router-dom";

const APPLICATIONS_PER_PAGE = 50;

export function Applications() {
    // Phase 5: Add pagination state with server-side filtering
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState<"new" | "rejected">("new");
    const {isSuccess, isError, error, data, refetch} = useGetApplicationsQuery({ page, limit: APPLICATIONS_PER_PAGE, filter });
    const users = data?.users || [];
    const pagination = data?.pagination;
    const [showModal, setShowModal] = useState(false);
    const [modalUser, setModalUser] = useState(null);

    // Reset page when filter changes
    const handleFilterChange = (newFilter: "new" | "rejected") => {
        setFilter(newFilter);
        setPage(1);
    };

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = (user) => {
        setModalUser(user);
        setShowModal(true);
    };

    // // sort users by createdAy desc:
    // var usersToShow = users;
    // if (usersToShow && usersToShow.length > 0) {
    //     usersToShow.sort((a, b) => {
    //         return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    //     });
    // }

    return (
        <div>
            {/* Filter by approved/rejected applications:*/}
            {/* Show a label and radio buttons:*/}
            <div>
                Select applications type:
            </div>
            <label style={{marginRight: 15}}>
                <input
                    type="radio"
                    value="new"
                    checked={filter === "new"}
                    onChange={() => handleFilterChange("new")}
                />
                New applications
            </label>
            <label>
                <input
                    type="radio"
                    value="rejected"
                    checked={filter === "rejected"}
                    onChange={() => handleFilterChange("rejected")}
                />
                Rejected applications
            </label>
            <div>
                <small>
                    All approved psychics will be moved to a&nbsp;
                    <Link to={`/psychic/`}>Psychics Section</Link>
                </small>
            </div>

            {/* Phase 5: Pagination controls */}
            {pagination && (
                <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                    <span className="text-muted">
                        Showing {users.length} of {pagination.total || 0} applications
                    </span>
                    <div className="d-flex gap-2 align-items-center">
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setPage(p => Math.max(1, p - 1))}
                            disabled={page === 1}
                        >
                            Previous
                        </Button>
                        <span className="px-2">Page {page} of {pagination.totalPages || 1}</span>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setPage(p => p + 1)}
                            disabled={!pagination.hasMore}
                        >
                            Next
                        </Button>
                    </div>
                </div>
            )}

            <Table striped bordered hover className="table-hover">
                <thead>
                <tr>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Created At</th>
                </tr>
                </thead>
                <tbody>
                {/* Phase 5: Server-side filtering - no client-side filter needed */}
                {users &&
                    users.map((user) => (
                        <tr key={user.userID} onClick={() => handleShowModal(user)}>
                            <td>{user.email}</td>
                            <td>{user.name}</td>
                            <td>{moment(user.created_at).format("MM-DD-YYYY")}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            {
                <ApplicationModal
                    user={modalUser}
                    show={showModal}
                    onHide={handleCloseModal}
                    onAction={() => refetch()}
                />
            }
        </div>
    );
}

export function ApplicationModal({user, show, onHide, onAction}) {
    const [updateUser, updateUserResult] = useUpdateUserMutation();

    const approve = () => {
        updateUser({userID: user.userID, approved: true})
            .unwrap()
            .catch((err) => {
                alert(err);
            })
            .finally(() => {
                onHide();
                onAction();
            });
    };

    const decline = () => {
        updateUser({userID: user.userID, approved: false, application_rejected: true, enabled: false})
            .unwrap()
            .catch((err) => {
                alert(err);
            })
            .finally(() => {
                onHide();
                onAction();
            });
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>User Application</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {user && (
                    <React.Fragment>
                        <Table>
                            <tbody>
                            <tr>
                                <td>Email</td>
                                <td>{user.email}</td>
                            </tr>
                            <tr>
                                <td>Name</td>
                                <td>{user.name}</td>
                            </tr>
                            <tr>
                                <td>Username</td>
                                <td>{user.username}</td>
                            </tr>
                            <tr>
                                <td>Created On</td>
                                <td>{moment(user.created_at).format("MM-DD-YYYY HH:mm:ss")}</td>
                            </tr>
                            </tbody>
                        </Table>
                        <h3>Questionnaire</h3>
                        {user.registrationAnswers
                            ? (user.registrationAnswers as RegistrationAnswer[]).map((answer, index) => {
                                return (
                                    <div key={answer.id || index}>
                                        <p className="bold">{answer.registrationQuestion.title}</p>
                                        <p>{answer.answer}</p>
                                    </div>
                                );
                            })
                            : null}
                    </React.Fragment>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="danger" onClick={decline}>
                    Decline
                </Button>
                <Button variant="success" onClick={approve}>
                    Approve
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
